var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-view',{staticClass:"safe-areas",attrs:{"main":"","url":"/"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }